import { DEFAULT_FONT_SIZE } from '../../../constants';

export default {
  profileImage: {
    width: 200
  },
  secondaryTitle: {
    fontSize: DEFAULT_FONT_SIZE + 6,
  },
};



// WEBPACK FOOTER //
// ./src/views/user/profile/Profile.styles.js